import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import styles from "./TooltipIconValue.module.scss";

const _text = [
  "The value of the choice which is used in the generation process.",
  "If you want to use the name of the choice as the value, you may leave this field blank."
];

function TooltipIconValue({ handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <>
        {_text.map((e, index) => (
          <div key={index} className={styles["tooltip__line"]}>
            {e}
          </div>
        ))}
      </>
    </DefaultTooltip>
  );
}

export default TooltipIconValue;
